import { Navigate } from 'react-router-dom';
import { useAuth, type EffectivePermissions } from '../lib/auth';

type Props = {
  need:
    | keyof Pick<
        EffectivePermissions,
        | 'canHome'
        | 'canCommunity'
        | 'canVolunteering'
        | 'canViewVolunteering'
        | 'canApproveVolunteeringCoordinator'
        | 'canApproveVolunteeringHr'
        | 'canDonations'
        | 'canPaymentMethods'
        | 'canChat'
      >
    | 'super';
  children: React.ReactNode;
};

// Route-level guard: sends the user to the first tab they DO have access
// to (rather than to a shared "overview" — the dashboard no longer has
// one). If they have zero section permissions they land on `/no-access`
// which the shell renders as a friendly "no permissions" card.
export default function Guard({ need, children }: Props) {
  const { permissions } = useAuth();
  const allowed =
    need === 'super' ? permissions.is_super_admin : permissions[need];
  if (allowed) return <>{children}</>;
  const fallback =
    permissions.canHome ? '/home/slides'
      : permissions.canDonations ? '/donations'
      : permissions.canPaymentMethods ? '/payment-methods'
      : permissions.canVolunteering ? '/volunteering'
      : permissions.canViewVolunteering ? '/volunteering/registrations'
      : permissions.canCommunity ? '/community'
      : permissions.canChat ? '/community/chat'
      : '/no-access';
  return <Navigate to={fallback} replace />;
}
